
import React, {FC, HTMLAttributes} from 'react';
import ArrowDown from 'assets/icons/arrow-down.svg';
import ArrowUp from 'assets/icons/arrow-up.svg';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

interface ArrowProps extends HTMLAttributes<object> {
	open: boolean;
	className?: string;
}

const ArrowIcon: FC<ArrowProps> = ({open, className, ...rest}) => {
	return (
		<div {...rest} className={classNames(styles.icon, className)}>
			{open ? <ArrowUp /> : <ArrowDown />}
		</div>
	);
};

export default ArrowIcon;
